import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Modal, Select } from '@opendate-app/setlist';

const bankLinkLabel = (venueBankLink) => `${venueBankLink.name} ••${venueBankLink.mask}`;

const PayoutSetupModal = ({
  venueOwnership,
  payoutSetup,
  onSave,
  onClose
}) => {
  const verifiedBankLinks = payoutSetup.verifiedBankLinks || [];
  const [selectedId, setSelectedId] = useState(
    verifiedBankLinks.length === 1 ? verifiedBankLinks[0].id : null
  );
  const [saving, setSaving] = useState(false);

  const selectedLink = verifiedBankLinks.find((link) => link.id === selectedId);
  const canSave = !!selectedLink && !saving;

  const save = () => {
    if(!canSave){
      return;
    }

    setSaving(true);
    Promise.resolve(onSave(venueOwnership, selectedLink))
      .then((saved) => {
        if(!saved){
          setSaving(false);
        }
      });
  };

  return (
    <Modal
      open
      onClose={onClose}
      type="warning"
      title={`Set up payouts for ${venueOwnership.venueable.name}`}
      description="Opendate sends this venue's ticket revenue to a bank account you choose. Until you choose one, payouts for this venue will be held."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            I'll do this later
          </Button>
          {verifiedBankLinks.length > 0 ? (
            <Button variant="primary" disabled={!canSave} onClick={save}>
              Save
            </Button>
          ) : (
            <Button variant="primary" as="a" href={payoutSetup.financeSettingsPath}>
              Add a bank account
            </Button>
          )}
        </>
      }
    >
      {verifiedBankLinks.length > 0 ? (
        <Select
          label="Payout bank account"
          placeholder="Choose a bank account"
          options={verifiedBankLinks.map((link) => ({ value: link.id, label: bankLinkLabel(link) }))}
          value={selectedId}
          onChange={(value) => setSelectedId(value)}
        />
      ) : null}
    </Modal>
  );
};

PayoutSetupModal.propTypes = {
  venueOwnership: PropTypes.object.isRequired,
  payoutSetup: PropTypes.shape({
    enabled: PropTypes.bool,
    financeSettingsPath: PropTypes.string,
    verifiedBankLinks: PropTypes.array
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default PayoutSetupModal;
